module.exports = __webpack_public_path__ + "media/photo/it_managementestbg-6721d7fd.jpg";